import React, { useRef } from "react";

import { ExtraClassNames, concatClassNames } from "../../utils/styles";
import { NavMenuRefsProvider } from "./context";

import styles from "./ScrollNavMenuContainer.module.scss";

export type ScrollNavMenuContainerClassNames = ExtraClassNames<
    "navMenuFullBleed" | "navItemList"
>;

export const ScrollNavMenuContainer = (
    props: React.PropsWithChildren<{
        classNames?: ScrollNavMenuContainerClassNames;
    }>,
) => {
    const fullBleedRef = useRef<HTMLDivElement | null>(null);
    const navLinksRef = useRef<HTMLUListElement | null>(null);
    return (
        <NavMenuRefsProvider value={{ fullBleedRef, navLinksRef }}>
            <div
                ref={fullBleedRef}
                className={concatClassNames([
                    styles.navMenuFullBleed,
                    props.classNames?.navMenuFullBleed,
                ])}
            >
                <nav>
                    <ul
                        ref={navLinksRef}
                        className={concatClassNames([
                            styles.navItemList,
                            props.classNames?.navItemList,
                        ])}
                    >
                        {props.children}
                    </ul>
                </nav>
            </div>
        </NavMenuRefsProvider>
    );
};
